import _default from './Table';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Table/index.js
// module id = 2697
// module chunks = 1